import { useEffect, useRef } from 'react';

export default function TouchControls({ visible, onInput, onRelease, feedbackRefs, holdFeedbackRefs }) {
  const pointers = useRef(new Map());
  useEffect(() => { if (!visible) pointers.current.clear(); }, [visible]);
  if (!visible) return null;
  const bindHold = (lane, key) => (node) => {
    if (!holdFeedbackRefs) return;
    if (!holdFeedbackRefs.current[lane]) holdFeedbackRefs.current[lane] = {};
    holdFeedbackRefs.current[lane][key] = node;
  };

  const release = (event) => {
    const lane = pointers.current.get(event.pointerId);
    if (!lane) return;
    pointers.current.delete(event.pointerId);
    onRelease?.(lane, `pointer-${event.pointerId}`, event.timeStamp);
  };

  return (
    <div className="rhythm-touch-controls">
      {['left', 'right'].map((lane) => (
        <div className="rhythm-lane-zone" key={lane}>
          <button
            type="button"
            aria-label={lane === 'left' ? 'Tocar carril izquierdo' : 'Tocar carril derecho'}
            className={`rhythm-lane rhythm-lane-${lane}`}
            onPointerDown={(event) => {
              if (event.button !== 0) return;
              event.preventDefault();
              event.currentTarget.setPointerCapture(event.pointerId);
              pointers.current.set(event.pointerId, lane);
              onInput(lane, `pointer-${event.pointerId}`, event.timeStamp);
            }}
            onPointerUp={release}
            onPointerCancel={release}
            onLostPointerCapture={release}
            onKeyDown={(event) => {
              if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                if (!event.repeat) onInput(lane, `button-${lane}`, event.timeStamp);
              }
            }}
            onKeyUp={(event) => {
              if (event.key === ' ' || event.key === 'Enter') onRelease(lane, `button-${lane}`, event.timeStamp);
            }}
            onBlur={() => onRelease(lane, `button-${lane}`)}
          >
            <span className="rhythm-judgement" ref={(node) => { feedbackRefs.current[lane] = node; }}>
              <strong />
              <small />
            </span>
            <span className="rhythm-pad">
              <b>{lane === 'left' ? '←' : '→'}</b>
              <span>{lane === 'left' ? 'IZQ.' : 'DER.'}</span>
            </span>
          </button>
          <span className="rhythm-hold-feedback" ref={bindHold(lane, 'panel')} hidden>
            <span className="rhythm-hold-label" ref={bindHold(lane, 'label')} role="status" />
            <progress
              className="rhythm-semantic-meter"
              ref={bindHold(lane, 'meter')}
              max="100"
              value="0"
              aria-label={`Nota sostenida ${lane === 'left' ? 'izquierda' : 'derecha'}`}
            />
            <span className="rhythm-hold-track" aria-hidden="true">
              <span ref={bindHold(lane, 'fill')} />
            </span>
          </span>
        </div>
      ))}
    </div>
  );
}
